import React from 'react'
import Landing from '../components/Landing/Landing'
import Navbar from '../components/Navbar/Navbar'

const Home = () => {
  return (
    <div>
        <Navbar/>
        <Landing/>
    </div>
  )
}

export default Home